import(/* webpackMode: "eager" */ "/usr/src/app/app/[locale]/page.tsx");
